<template>
  <footer class="step__footer">
    <div class="step__footer-buttons">
      <Btn
        aaav-if="!isFirst && isEnabled(currentStep - 1)"
        class="step__footer-btn --previous"
        :class="{ invisible: isFirst || !isEnabled(currentStep - 1) }"
        variant="outline-secondary"
        icon="angle-left"
        disabled-icon="angle-left"
        :disabled="isFirst || !isEnabled(currentStep - 1)"
        @click="previousStep"
      >
        {{ $t("previous_step") }}
      </Btn>

      <Btn
        aaav-if="!isLast && isEnabled(currentStep + 1)"
        class="step__footer-btn --next"
        :class="{ invisible: isLast || !isEnabled(currentStep + 1) }"
        variant="outline-secondary"
        icon="angle-right"
        disabled-icon="angle-right"
        :disabled="isLast || !isEnabled(currentStep + 1)"
        :icon-right="true"
        @click="nextStep"
      >
        {{ $t("next_step") }}
      </Btn>

      <Btn
        v-if="isEnabled(3) && !formDisabled && !isSending"
        class="step__footer-btn --draft"
        variant="secondary"
        icon="pen"
        @click="draft"
      >
        {{ $t("save_draft") }}
      </Btn>

      <Btn
        v-if="isLast && !formDisabled"
        class="step__footer-btn --send"
        variant="primary"
        icon="check"
        :disabled="isSending"
        disabled-title="Wysyłam..."
        title="Wyślij"
        @click="submit"
      />

      <Btn
        v-if="isAdmin && !moderationDisabled"
        class="step__footer-btn --send"
        variant="primary"
        icon="check"
        :disabled="isSending"
        disabled-title="Zapisuję..."
        title="Zapisz"
        @click="submit"
      />

      <!-- <Btn
      v-if="formDisabled"
      class="step__footer-btn --back"
      variant="outline-secondary"
      icon="angle-right"
      :icon-right="true"
      @click="back"
    >
      {{ $t("back") }}
    </Btn> -->
    </div>
    <div v-if="isDebugMode">
      <hr />

      <TextareaControl
        id="applicantComments"
        v-model="reportMessage"
        label="W razie wystąpienia błędu aplikacji, prosimy o krótki opis sytuacji i wysłanie raportu."
        description="Prosimy nie używać tego formularza do przesyłania pomysłów i usprawnień. Zamiast tego prosimy skontaktować się z Izbą POLMED."
        :disabled="formDisabled"
      />
      <alert v-if="reportMessageEmpty" show variant="danger">
        Proszę krótko opisać problem: po jakim działaniu wystąpił błąd, jaka
        przeglądarka i system operacyjny.
      </alert>
      <alert v-if="reportSent === true" variant="success" show>{{
        reportSentMessage
      }}</alert>
      <alert v-if="reportSent === false" variant="danger" show>{{
        reportSentMessage
      }}</alert>
      <Btn icon="" title="Wyślij raport" @click="sendReport"></Btn>
    </div>
    <div v-if="isDevMode">
      <hr />
      <pre>{{ form }}</pre>
    </div>
  </footer>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import TextareaControl from "@/components/Controls/TextareaControl";
import { detect } from "detect-browser";
import ReportApi from "@/api/Report";

export default {
  name: "BaseCertificationFormStepFooter",
  components: {
    TextareaControl
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    v: {
      type: Object,
      required: true
    },
    isSending: {
      type: Boolean,
      default: false
    },
    isSent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.value,
      browser: detect(),
      reportSent: null,
      reportSentMessage: "",
      reportMessage: "",
      reportMessageEmpty: false
    };
  },
  computed: {
    ...mapState("Form", ["currentStep", "formDisabled"]),
    ...mapState("Event", ["moderationDisabled"]),
    ...mapState("User", ["user"]),
    ...mapGetters("Form", ["isLast", "isFirst", "isEnabled"]),
    ...mapGetters("User", ["isAdmin"]),
    ...mapGetters("App", ["isDevMode", "isDebugMode"])
  },
  methods: {
    // ...mapActions('Form', ['previousStep', 'nextStep']),
    previousStep() {
      let self = this;
      this.scrollTop(function() {
        self.v[`step${self.currentStep}`].$touch();
        self.$store.dispatch("Form/previousStep");
      });
    },
    nextStep() {
      let self = this;
      this.scrollTop(function() {
        self.v[`step${self.currentStep}`].$touch();
        self.$store.dispatch("Form/nextStep");
      });
    },
    submit(e) {
      this.$emit("form:submit", e);
    },
    draft(e) {
      this.$emit("form:draft", e);
    },
    back() {
      history.back();
    },
    scrollTop(onDone) {
      const el = document.getElementById("app");
      this.$scrollTo(el, 300, { offset: -40, onDone });
    },
    async sendReport() {
      if (this.reportMessage == "") {
        this.reportMessageEmpty = true;
        return false;
      }
      this.reportMessageEmpty = false;
      const data = {
        event: this.form,
        user: this.user,
        browser: this.browser,
        message: this.reportMessage
      };
      const { success, message } = await ReportApi.send(data).then(res => res);
      this.reportSent = success;
      this.reportSentMessage = message;
    }
  }
};
</script>

<style lang="scss">
.step__footer {
  margin: 30px 0;

  &-buttons {
    display: flex;
    flex-wrap: wrap;
  }

  @media (max-width: 640px) {
    .btn {
      font-size: 0.9em;
      line-height: 1.8;
      width: calc(50% - 10px);
      margin-bottom: 10px;
    }
  }

  &-btn {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }

    @media (min-width: 800px) {
      &.--draft,
      &.--next {
        margin-left: auto;
      }
      &.--next + &.--draft {
        margin-left: 0;
      }
    }
  }
}
</style>
